import React, { useState, useEffect, useRef } from "react";
import Navigation from "../../../common/Navigation";
import growthicon from "../../../assets/img/GG210.png";
import Button from "@material-ui/core/Button";
import axios from "axios";
import * as yup from "yup";
import { Formik } from "formik";

import { API_AUTH } from "../../../utils/config";
import Notifier from "../../../component/aside/Notifier";



// component for forget password

const ForgetPassword = (props) => {



  const [err, seterr] = useState("");

  const [message, setmessage] = useState("");
  const textInput = useRef(null);
  const signupValidationSchema = yup.object().shape({
    email: yup
      .string()
      .email("Please enter valid email")
      .required("Email Address is Required"),
  });

  useEffect(() => {
    // checkingCurrentUser()
    textInput.current.focus();
  });

  // const checkingCurrentUser = () => {
  //   axios.get(`${API_AUTH}/v1/api/auth/isLoggedIn`, { withCredentials: true }).then((response) => {
  //     if (response.data) {
  //       history.push({
  //         pathname: "/dashboard",

  //       });
  //     }

  //   }).catch((err) => {
  //     console.log(err)
  //   })
  // }

  // function for submit button triggers

  const onSubmit = async (email) => {
    let body = {
      email,
    };
    console.log(body);
    await axios
      .post(`${API_AUTH}/v1/api/auth/forgot-password`, body, {
        withCredentials: true,
      })
      .then((response) => {
        console.log(response);
        if (response.data.ok) {
          setmessage("please check email");
          setTimeout(() => {
            setmessage("");
          }, 2000);
        
        }

        
      })
      .catch((err) => {
        if ( err.response.data.ok===false) {
          seterr("Email Not Found");
        }
      });
  };

 
  console.log(err);

  return (
    <div>
      <Navigation show="true" />
      <div className="sign-container">
        <Formik
          validationSchema={signupValidationSchema}
          initialValues={{ email: "" }}
          onSubmit={(values) => onSubmit(values.email)}
        >
          {({
            handleChange,
            handleSubmit,
            values,
            errors,
            touched,
            isValid,
          }) => (
            <>
              <div className="child-signcontainer">
                <div className="child-firstcontainer">
                  <img
                    style={{ marginRight: "20px" }}
                    src={growthicon}
                    height="60"
                    width="170"
                    alt="PION global"
                    id="logo"
                  ></img>

                  <span
                    style={{
                      fontWeight: "500",
                      fontSize: "1.5rem",
                      marginTop: "1rem",
                    }}
                  >
                    Forgot Password
                  </span>
                </div>

                <div className="child-secondcontainer">
                  <span style={{ fontWeight: 500, fontSize: "20px" }}>
                    Enter Email
                  </span>

                  <div className="sign-form">
                    <input
                      type="email"
                      onKeyPress={(e) => {
                        console.log(e);
                        if (e.code === "Enter") {
                          handleSubmit();
                        }
                      }}
                      name="email"
                      ref={textInput}
                      // onKeyPress={(values)=>onkeySubmit(values.email)}
                      placeholder="Email"
                      onChange={(email) => {
                        handleChange(email);
                        seterr("");
                     
                      }}
                      value={values.email}
                      autoComplete="off"
                      required
                    ></input>
                    {errors.email && touched.email && (
                      <span style={{ fontSize: 15, color: "red" }}>
                        {errors.email}
                      </span>
                    )}

                    {err && (
                      <span style={{ fontSize: 15, color: "red" }}>{err}</span>
                    )}

                    {/* <span  style={{ fontSize: 15, color: 'red' }}>{validemail}</span> */}
                  </div>
                </div>
                <div className="log-button">
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      handleSubmit();
                    }}
                    style={{ background: "#005500" }}
                  >
                    Next
                  </Button>
                </div>
              </div>
            </>
          )}
        </Formik>
        {message && <Notifier message={message} />}
      </div>
    </div>
  );
};

export default ForgetPassword;
